import { action, observable } from 'mobx'

import Ds from './ds'

class Carriers {
  @observable data = []

  @observable ds = new Ds()

  @action loadAllCarriers() {
    this.ds.query(`{ carriers(hash: "${ localStorage.getItem('userHash') }") { id name } }`, (data) => {
      this.data = data.carriers
    })
  }

  @action newCarrier(name) {
    this.ds.query(`mutation { addCarrier(name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllCarriers()
    })
  }

  @action updateCarrier(id, name) {
    this.ds.query(`mutation { updateCarrier(id: ${ id }, name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllCarriers()
    })
  }

  @action deleteCarrier(id) {
    this.ds.query(`mutation { deleteCarrier(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllCarriers()
    })
  }
}

export default new Carriers()



// WEBPACK FOOTER //
// ./src/stores/carriers.js